export default "__VITE_ASSET__Dz$jkJOa__"